// Package Imports
import { Col, Row } from 'antd';

import DMNViewer from 'pages/rules/DMNViewer';
import RuleConfiguration from 'pages/rules/ruleConfiguration';
import classNames from 'core/utils/classNames';
import { useRulesCreateState } from 'pages/rules/context/RulesCreateStateContext';

export const ruleTypeItem = (
  fileType,
  defaultFileListObj,
  uploadType,
  form,
  type,
  clawbackType
) => {
  const state = useRulesCreateState();
  let message;
  if (state.hasInvalidOutputColumn) {
    message =
      'Invalid Output Column : Output Column should match with unified columns';
  } else if (state.hasInvalidInputColumn) {
    message =
      'Invalid Input Column : Input Column should match with unified columns';
  }
  const scrollToDiv = () => {
    const element = document.getElementById('scrollDmn');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="">
      <Row>
        <Col xs={24} sm={24} lg={24}>
          <DMNViewer
            defaultFileListObj={defaultFileListObj}
            form={form}
            message={message}
            fileType={fileType}
            type={type}
            clawbackType={clawbackType}
          />
          {state.dmnErrors.length > 0 ? (
            <div
              className="dmn-error mx-auto max-w-3xl bg-neutral-10 rounded-lg border border-neutral-900"
              onClick={scrollToDiv}
            >
              <h4 className="text-md text-center font-semibold text-danger-500 mb-md">
                Error: Failed to validate DMN data
              </h4>
              <table className="min-w-full table-auto text-center border-neutral-900">
                <thead>
                  <tr className="bg-primary text-neutral-10">
                    <th className="px-md py-sm font-semibold rounded-tl-lg">
                      Row
                    </th>
                    <th className="px-md py-sm font-semibold th-border">
                      Column
                    </th>
                    <th className="px-md py-sm font-semibold th-border">
                      Value
                    </th>
                    <th className="px-md py-sm font-semibold rounded-tr-lg">
                      Error
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {state.dmnErrors.map((error, index) => (
                    <tr key={index}>
                      <td className="border px-md py-sm">{error.row}</td>
                      <td className="border px-md py-sm">{error.col}</td>
                      <td className="border px-md py-sm">{error.value}</td>
                      <td className="border px-md py-sm">{error.error}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : null}
        </Col>
      </Row>
    </div>
  );
};

export const ruleOutputItem = () => {
  const state = useRulesCreateState();
  return (
    <div
      className={`$${
        state.inputSourceFileData === undefined
          ? 'rule-config-card mt-lg mb-3xl'
          : 'mt-lg mb-3xl'
      }`}
    >
      {state.inputSourceFileData === undefined ||
      state.hasInvalidOutputColumn ? (
        <p
          className={classNames(
            'text-lg text-center font-semibold pb-md',
            state.hasInvalidOutputColumn
              ? 'text-danger-500'
              : 'text-neutral-900'
          )}
        >
          {state.hasInvalidOutputColumn
            ? 'Invalid Output Column : Output Column should match with unified columns'
            : 'Please configure the rule.'}
        </p>
      ) : (
        <Row>
          <Col xs={24} sm={24} lg={18}>
            <RuleConfiguration
              outputValue={state.outputValue}
              type={state.pageType}
            />
          </Col>
        </Row>
      )}
    </div>
  );
};
